export default "__VITE_ASSET__BNffq11X__"